import { render } from "./EmailChangeSuccessDialog.vue?vue&type=template&id=e1a03684"
import script from "./EmailChangeSuccessDialog.vue?vue&type=script&lang=js"
export * from "./EmailChangeSuccessDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__